import React from 'react'
import { DurationInlineInput } from '@ztechapps/webui.input'
import { IconValueBlock } from '@ztechapps/webui.util'
import { useFormatWorkdayTime } from '@ztechapps/common.hook'
import type { TaskInlineInputProps } from './TaskInlineInput'
import { TaskInlineInput } from './TaskInlineInput'
import type { SetOptional } from 'type-fest'

const TimeSpentInlineInputContent = ({ value }: { value: string }) => {
  return <IconValueBlock icon="clock" value={value} />
}
export const TimeSpentInlineInputDisplayContent = ({ value }) => {
  const { formatTime } = useFormatWorkdayTime()
  return <TimeSpentInlineInputContent value={formatTime(value)} />
}
export const TimeSpentInlineInputEmptyContent = () => {
  return <TimeSpentInlineInputContent value={'00:00'} />
}

export type TaskTimeSpentInlineInputProps = SetOptional<TaskInlineInputProps, 'name'>

export const TaskTimeSpentInlineInput = ({
  displayContent,
  help = 'The total time spent for this task.',
  name = 'timeSpent',
  label = 'Time Spent',
  emptyContent,
  parentInputComponent,
  inputProps,
  ...props
}: SetOptional<TaskInlineInputProps, 'name'>) => {
  const { workdayConfig } = useFormatWorkdayTime()

  displayContent = displayContent ?? ((value) => <TimeSpentInlineInputDisplayContent value={value} />)
  emptyContent = emptyContent ?? (() => <TimeSpentInlineInputEmptyContent />)

  const ParentInput = parentInputComponent || TaskInlineInput

  return (
    <ParentInput
      help={help}
      label={label}
      name={name}
      displayContent={displayContent}
      emptyContent={emptyContent}
      parentInputComponent={DurationInlineInput}
      inputProps={{ ...inputProps, workdayConfig }}
      {...props}
    />
  )
}
